import "../../App.css";
import React from "react";
import { useEffect, useRef, useState, useMemo, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import HorseRacingSchedule from "../../components/horseRacingSchedule";
import GreyhoundRacingSchedule from "../../components/greyhoundRacingSchedule";
import PoliticsOG from "../../components/politics";
import Lottery from "../../components/lottery";
import axios from "axios";
import Appconfig from "../../config/config";
import { useSignal } from "@preact/signals-react";
import { allEventsSignal } from "../../APIs/apiService";
import TableRow from "../../components/TableRow";
import MobileTableRow from "../../components/mobileTableRow";
import News from "../../components/news";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import { Modal, Input, Carousel, Skeleton } from "antd";
import SkyLoader from "../../components/sky-loader";
import { useSelector, useDispatch } from "react-redux";
import { getAllEvents } from "../../redux/slice/event/eventSlice";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import { getLoginUser } from "../../redux/slice/userData/userDataSlice";
import { getBanner } from "../../redux/slice/banner/bannerSlice";

import { useWebSocket } from "../../context/WebSocketProvider";
import WebSocketEventEmitter from "../../context/eventEmitter";
import Footer from "pages/footer";
// import { WebSocketContext } from '../../context/websocket';
// import { Login } from '../../pages/login';
import LoginModal from "components/LoginModal";

function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 3. ADD STATE FOR MODAL
  const [showLoginModal, setShowLoginModal] = useState(false);

  const { sendMessage, marketDataMsg, socketStatus } = useWebSocket();

  const userInfos = useSelector((state) => state.events); // Use selector to access state
  const userInfo = useSelector((state) => state?.userInfo?.userdata); // get login user details
  const banners = useSelector((state) => state?.banners?.banners); // get login user details
  // const websocket = useContext(WebSocketContext);
  // console.log('banners',banners);

  let casinoBlock = "No";
  casinoBlock = userInfo?.is_casino_bet_lock;

  const [eventType, setEventType] = useState(4);
  const [activeCasino, setActiveCasino] = useState("popular");
  const [selectedGame, setSelectedGame] = useState(4);
  // console.log('userInfo', userInfo);
  const [allEvents, setAllEvents] = useState([]);
  const [events, setEvents] = useState([]);
  // console.log('events',events);
  // const [casinoBlock, setCasinoBlock] = useState('No');
  // console.log('events ->>>>>>>>>>', events);
  const [isEventLoading, setIsEventLoading] = useState(true);
  // const [banners, setBanners] = useState([]);
  const [changePassModal, setChangePassModal] = useState(true);
  const [loading, setLoading] = useState(false);

  const allEvent = useSignal(allEventsSignal);

  const gamesNav = [
    {
      title: "Vimaan",
      svg: <img className="w-[50px] h-[28px]" src="/other/aviator.webp" />,
      id: "4",
    },
    {
      title: "Cricket",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == 4 && `fill-[white]`
          } relative top-[3px]`}
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 59.35 59.35"
          xmlSpace="preserve"
        >
          <path
            d="M48.764,0.058c-2.251,2.13-12.669,11.895-12.669,11.895l1.021,1.061l-0.951,0.917
                 c-1.031-0.634-2.398-0.703-3.527,0.37c-1.826,1.734-4.595,3.513-7.282,4.44c-0.173-0.203-0.345-0.409-0.518-0.612
                 c3.043-1.583,8.537-4.855,8.667-4.934l0.011-0.005l-0.103-0.037l-0.289-0.108c-0.115-0.034-0.231-0.067-0.354-0.084
                 c-0.416-0.055-0.874-0.008-1.367,0.17c-2.701,0.976-5.667,2.253-8.603,2.989c-3.622-2.055-8.258,3.412-5.012,7.308
                 c3.026,3.631,6.169,6.927,8.513,11.001c-1.349,2.25-4.492,3.467-6.457,5.068c-3.831,3.121-4.378,8.281-5.932,12.629
                 c-1.283,3.586,4.41,5.113,5.681,1.564c1.532-4.287,1.858-8.438,5.968-11.107c0.46-0.299,0.918-0.6,1.368-0.903
                 c-0.597,2.252-1.079,4.519-0.74,6.96c0.412,2.966,1.276,5.878,2.278,8.693c1.261,3.554,6.955,2.022,5.68-1.565
                 c-0.851-2.388-1.556-4.831-2.06-7.313c-0.82-4.032,1.353-8.114,1.998-12.174c1.086-1.263,1.547-3.072,0.59-4.963
                 c-1.469-2.901-3.351-5.458-5.366-7.92c2.793-1.229,5.411-2.954,7.493-4.932c0.968-0.918,1.08-2.026,0.705-2.965l1.039-1.001
                 l1.021,1.061l12.67-11.894C52.237,3.667,52.863-0.536,48.764,0.058z"
          ></path>
          <path
            d="M18.411,15.114c0.288-0.333,0.514-0.698,0.686-1.079l0.415-0.056
                 c0.028-0.003,0.056-0.011,0.082-0.025c0.288-0.146,0.517-0.327,0.697-0.536c1.352-1.568-0.067-4.621-0.137-4.768
                 c-0.059-0.125-0.209-0.179-0.336-0.121l-1.501,0.699c-0.114-0.124-0.235-0.244-0.366-0.357c-0.201-0.173-0.414-0.321-0.634-0.452
                 l1.409-1.633l-0.622-0.538l-1.558,1.809c-1.672-0.596-3.608-0.15-4.837,1.274c-1.599,1.853-1.392,4.648,0.459,6.243
                 C14.019,17.171,16.814,16.964,18.411,15.114z M19.401,13.482l-0.106,0.015c0.168-0.562,0.22-1.146,0.162-1.721l0.898-0.25
                 C20.368,12.321,20.148,13.083,19.401,13.482z M19.793,9.1c0.15,0.366,0.424,1.121,0.524,1.918c-0.02,0.001-0.04,0.003-0.061,0.009
                 l-0.88,0.245c-0.128-0.582-0.373-1.14-0.733-1.638L19.793,9.1z"
          ></path>
          <path
            d="M8.098,33.294c-0.564,0-1.019,0.455-1.019,1.02v20.198c0,0.563,0.455,1.021,1.019,1.021
                 s1.021-0.457,1.021-1.021V34.314C9.119,33.749,8.662,33.294,8.098,33.294z"
          ></path>
          <path
            d="M12.14,33.294c-0.563,0-1.019,0.455-1.019,1.02v20.198c0,0.563,0.457,1.021,1.019,1.021
                 c0.213,0,0.411-0.065,0.573-0.178c-0.449-0.943-0.49-2.033-0.096-3.136c0.195-0.542,0.371-1.099,0.543-1.668V34.314
                 C13.161,33.749,12.705,33.294,12.14,33.294z"
          ></path>
          <path
            d="M15.15,34.314v10.049c0.526-1.26,1.177-2.463,2.04-3.561v-6.488c0-0.562-0.455-1.02-1.019-1.02
                 C15.605,33.294,15.15,33.749,15.15,34.314z"
          ></path>
          <path
            d="M8.644,33.294h2.611c0.301,0,0.545-0.244,0.545-0.547c0-0.299-0.244-0.543-0.545-0.543H8.644
                 c-0.302,0-0.546,0.244-0.546,0.543C8.098,33.05,8.341,33.294,8.644,33.294z"
          ></path>
          <path
            d="M15.625,32.204h-2.612c-0.301,0-0.545,0.244-0.545,0.543c0,0.303,0.244,0.547,0.545,0.547h2.612
                 c0.301,0,0.546-0.244,0.546-0.547C16.171,32.451,15.926,32.204,15.625,32.204z"
          ></path>
          <path
            d="M49.427,15.243c-0.004,0.268-0.051,0.592-0.08,0.965c-0.057,0.369-0.113,0.788-0.223,1.235
                 c-0.099,0.449-0.246,0.924-0.414,1.42c-0.101,0.243-0.201,0.493-0.307,0.748c-0.121,0.248-0.244,0.5-0.371,0.757
                 c-0.277,0.5-0.585,1.004-0.943,1.486c-0.355,0.482-0.746,0.952-1.172,1.388c-1.688,1.769-3.815,3.033-5.463,3.798
                 c-0.826,0.386-1.539,0.653-2.039,0.827c-0.504,0.171-0.787,0.245-0.787,0.245l0.16,0.567c0,0,0.31-0.091,0.818-0.282
                 c0.512-0.194,1.23-0.489,2.062-0.909c1.662-0.833,3.797-2.189,5.463-4.045c0.42-0.457,0.804-0.947,1.152-1.45
                 c0.35-0.5,0.646-1.024,0.912-1.54c0.121-0.265,0.238-0.525,0.354-0.779c0.099-0.261,0.193-0.517,0.285-0.766
                 c0.158-0.509,0.293-0.991,0.377-1.448c0.097-0.452,0.142-0.875,0.186-1.247c0.021-0.375,0.057-0.701,0.055-0.97
                 c-0.005-0.539-0.006-0.846-0.006-0.846S49.442,14.705,49.427,15.243z"
          ></path>
        </svg>
      ),
      id: 4,
    },
    {
      title: "Tennis",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == 2 && `fill-[white]`
          } relative top-[3px]`}
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 57.549 57.549"
          xmlSpace="preserve"
        >
          <circle cx="32.734" cy="13.533" r="5.021"></circle>
          <path
            d="M45.398,10.474c0.04-2.682-4.115-2.678-4.154,0c-0.037,2.37-0.652,7.533-3.209,8.972
			c-2.267-0.901-4.728,0.627-5.402,2.624c-0.035,0.058-0.076,0.104-0.109,0.168c-0.657,1.244-1.482,2.264-2.443,3.198
			c-1.064-1.001-1.947-2.229-2.951-3.271c-0.781-0.812-1.75-0.758-2.475-0.287l-4.211-4.538c1.574-1.904,1.015-5.333-1.373-7.908
			c-2.536-2.732-6.189-3.482-8.142-1.67c-1.952,1.812-1.477,5.511,1.058,8.243c2.391,2.574,5.767,3.387,7.783,1.958l4.224,4.551
			c-0.512,0.737-0.605,1.756,0.197,2.588c1.616,1.676,2.953,3.529,4.923,4.827c0.833,0.548,1.816,0.248,2.52-0.325
			c1.08-0.879,2.057-1.83,2.906-2.888c1.414,2.475,1.295,7.13,1.076,9.702c-0.033,0.396-0.011,0.76,0.051,1.097
			c-1.205,2.999-1.076,6.186-3.213,8.788c-1.285,1.568-2.732,3.025-4.194,4.432c-1.934,1.863,1.009,4.797,2.938,2.938
			c1.613-1.553,3.167-3.176,4.587-4.909c2.142-2.611,2.431-5.58,3.343-8.572c0.269,0.005,0.541-0.013,0.809-0.056
			c0.64,4.953,0.673,9.824-1.958,14.311c-1.356,2.317,2.235,4.408,3.59,2.098c3.763-6.42,3.087-13.353,1.94-20.475
			c-0.012-0.072-0.036-0.135-0.055-0.203c0.28-4.16-0.072-9.783-2.436-13.557C44.182,19.66,45.339,14.416,45.398,10.474z
			 M12.344,15.67c-2.352-2.535-2.839-5.922-1.084-7.551s5.097-0.891,7.45,1.644c2.351,2.536,2.838,5.923,1.085,7.552
			C18.04,18.945,14.698,18.207,12.344,15.67z"
          ></path>
          <circle cx="45.962" cy="1.86" r="1.86"></circle>
        </svg>
      ),
      id: 2,
    },
    {
      title: "Soccer",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == 1 && `fill-[white]`
          } relative top-[3px]`}
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="121.51px"
          height="121.511px"
          viewBox="0 0 121.51 121.511"
          xmlSpace="preserve"
        >
          <path
            d="M50.116,78.373c1.407-1.311,2.471-3.025,2.933-5.182l2.508-11.705c2.988,2.607,7.471,4.384,14.276,4.384
                 c3.083,0,5.581-2.499,5.581-5.581s-2.498-5.581-5.581-5.581c-8.561,0-8.806-3.124-9.396-10.67
                 c-0.107-1.369-0.218-2.784-0.414-4.165c-0.037-0.26-0.098-0.51-0.167-0.755c-0.474-4.417-3.961-8.051-7.603-9.816
                 c0,0-1.386-0.761-2.968-1.063c-1.514-0.289-3.268-0.299-3.268-0.299l-0.042-0.002c-1.549,0.045-3.184,0.345-4.738,0.911
                 c-0.465,0.065-0.93,0.184-1.383,0.373c-0.65,0.271-16.059,6.769-27.436,16.997c-2.292,2.061-2.479,5.589-0.418,7.881
                 c1.102,1.226,2.623,1.85,4.151,1.85c1.329,0,2.663-0.472,3.729-1.431c3.737-3.36,8.077-6.305,12.045-8.676l-4.676,21.822
                 c-0.707,3.301,0.33,6.325,2.293,8.714c-0.916,8.861-2.363,19.01-3.217,21.102c-0.925,1.873-6.905,7.602-12.799,12.258
                 c-2.857,2.259-3.345,6.406-1.087,9.265c1.302,1.647,3.231,2.508,5.181,2.508c1.431,0,2.871-0.463,4.082-1.419
                 c4.273-3.374,14.466-11.839,16.806-17.556c1.099-2.683,2.088-8.349,2.856-13.894l19.582,25.549
                 c1.299,1.695,3.258,2.584,5.24,2.584c1.399,0,2.812-0.443,4.007-1.36c2.893-2.216,3.439-6.356,1.225-9.248L50.116,78.373z"
          ></path>
          <circle cx="55.454" cy="14.376" r="14.376"></circle>
          <path
            d="M99.393,76.6c-6.368,0-11.549,5.184-11.549,11.551s5.181,11.549,11.549,11.549c6.367,0,11.55-5.182,11.55-11.549
                 S105.76,76.6,99.393,76.6z M95.846,79.462c0.085-0.167,0.459-0.901,0.771-1.51c0.115-0.229,0.224-0.439,0.305-0.595l0.039-0.078
                 l0.086-0.02c1.498-0.318,3.066-0.318,4.578-0.001l0.083,0.019l0.678,1.226c0.241,0.438,0.462,0.836,0.528,0.955l0.103,0.187
                 l-0.363,0.142c-0.153,0.06-0.382,0.147-0.646,0.251l-0.173,0.066c-0.735,0.287-1.68,0.655-2.127,0.828
                 c-0.146,0.059-0.238,0.094-0.26,0.102l-0.067,0.027l-0.161-0.065l-2.411-0.939c-0.315-0.122-0.582-0.227-0.739-0.288
                 c-0.039-0.015-0.075-0.029-0.101-0.039l-0.212-0.084L95.846,79.462z M90.98,88.27l-0.181,0.227
                 c-0.14,0.175-0.239,0.302-0.28,0.351l-0.127,0.154l-0.145-0.138c-0.014-0.012-0.026-0.025-0.038-0.036l-1.291-1.248
                 c-0.103-0.099-0.199-0.191-0.285-0.275l-0.258-0.25l0.009-0.088c0.146-1.534,0.607-2.995,1.373-4.346l0.043-0.077l2.765-0.479
                 v0.228l0.08,1.147c0.065,0.91,0.146,2.06,0.165,2.367c0.003,0.02,0.004,0.041,0.004,0.057l0.004,0.07l-0.03,0.063
                 c-0.017,0.022-0.06,0.075-0.124,0.159l-0.18,0.223C92.103,86.857,91.433,87.697,90.98,88.27z M95.784,97.863
                 c-0.211,0.107-0.407,0.209-0.568,0.289l-0.076,0.039l-0.077-0.032c-1.426-0.603-2.689-1.489-3.761-2.634l-0.063-0.066l0.094-0.581
                 l0.354-2.216l1.833,0.497c0.782,0.211,1.591,0.43,1.808,0.489l0.12,0.027l0.112,0.178l0.351,0.556
                 c0.304,0.478,0.709,1.12,1.027,1.624l0.192,0.304c0.088,0.14,0.162,0.255,0.215,0.34l0.038,0.062
                 c0.016,0.023,0.026,0.043,0.036,0.055l0.124,0.176L95.784,97.863z M97.156,91.115l-0.041-0.129
                 c-0.044-0.137-0.532-1.638-0.901-2.772l-0.456-1.403l0.11-0.078c0.162-0.112,2.382-1.68,3.153-2.228
                 c0.137-0.096,0.229-0.162,0.257-0.181l0.104-0.072l0.105,0.072c0.028,0.019,0.121,0.084,0.259,0.181
                 c0.772,0.549,2.991,2.116,3.152,2.229l0.11,0.076l-0.053,0.174l-0.517,1.58c-0.263,0.807-0.556,1.703-0.701,2.151l-0.131,0.402
                 h-4.452V91.115z M107.498,95.387c-1.054,1.167-2.368,2.112-3.81,2.735l-0.079,0.034l-0.077-0.038
                 c-0.174-0.087-0.388-0.193-0.608-0.304l-1.687-0.838l2.081-3.297l0.07-0.018c0.043-0.012,0.441-0.119,0.955-0.258l1.755-0.476
                 c0.366-0.1,0.656-0.179,0.766-0.208l0.183-0.049l0.063,0.178l0.081,0.438c0.064,0.352,0.154,0.85,0.233,1.297
                 c0.044,0.239,0.084,0.466,0.117,0.644l0.016,0.09L107.498,95.387z M109.757,87.666l-1.379,1.332l-0.128-0.148
                 c-0.019-0.02-0.042-0.051-0.071-0.092l-0.066-0.083c-0.104-0.126-0.251-0.312-0.419-0.522c-0.446-0.564-1.057-1.326-1.412-1.772
                 c-0.125-0.157-0.218-0.274-0.263-0.332l-0.069-0.087l0.007-0.15l0.238-3.418c0.002-0.044,0.006-0.082,0.01-0.109l0.021-0.211
                 l0.198,0.031c0.179,0.032,0.992,0.172,1.689,0.293c0.181,0.031,0.352,0.062,0.501,0.086l0.246,0.043l0.043,0.076
                 c0.783,1.375,1.251,2.875,1.392,4.453l0.008,0.09l-0.065,0.062C110.1,87.333,109.936,87.493,109.757,87.666z"
          ></path>
          <path
            d="M84.625,92.727c-0.405,0.228-0.977,0.555-1.628,0.967c-0.668,0.395-1.41,0.916-2.21,1.455
                 c-0.405,0.26-0.796,0.578-1.201,0.879c-0.403,0.307-0.813,0.617-1.223,0.928c-0.389,0.337-0.776,0.675-1.158,1.008
                 c-0.374,0.341-0.771,0.635-1.1,0.993c-0.333,0.348-0.654,0.684-0.96,1.001c-0.297,0.324-0.603,0.602-0.839,0.906
                 c-0.911,1.224-1.518,2.039-1.518,2.039s0.717-0.709,1.791-1.771c0.271-0.258,0.615-0.488,0.95-0.756
                 c0.341-0.262,0.698-0.538,1.069-0.823c0.361-0.294,0.798-0.524,1.204-0.796c0.414-0.263,0.833-0.527,1.254-0.795
                 c0.438-0.238,0.876-0.477,1.308-0.71c0.434-0.229,0.846-0.474,1.273-0.664c0.844-0.399,1.619-0.785,2.31-1.062
                 c0.685-0.301,1.251-0.52,1.646-0.668c0.408-0.149,0.642-0.236,0.642-0.236l-0.99-2.236C85.245,92.384,85.02,92.509,84.625,92.727z
                 "
          ></path>
        </svg>
      ),
      id: 1,
    },
    {
      title: "Horse Racing",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "horse-racing" && `fill-[white]`
          } relative top-[3px]`}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          width="512px"
          height="512px"
          viewBox="0 0 201.705 201.705"
          xmlSpace="preserve"
        >
          <path
            d="M39.41,67.344c-2.506-2.069-1.652-7.699,1.9-12.546c3.576-4.867,8.497-7.125,11.003-5.036   c2.512,2.081,1.658,7.699-1.9,12.551C46.849,67.187,41.922,69.433,39.41,67.344z M111.832,26.914c0-4.699-3.579-8.512-7.997-8.512   c-4.43,0-8.009,3.812-8.009,8.512c0,4.69,3.579,8.497,8.009,8.497C108.264,35.423,111.832,31.616,111.832,26.914z M9.655,128.497   c-0.647,0-1.265-0.09-1.889-0.143c1.617,18.997,7.445,36.99,17.085,52.771c0.018-0.792,0-1.525,0.074-2.394l0.168-2.246   l1.755-1.401c0.092-0.076,0.29-0.213,0.538-0.378c-7.903-14.092-12.72-29.896-14.168-46.518   C12.017,128.354,10.817,128.497,9.655,128.497z M104.482,11.484c25.141,0,47.957,11.747,64.554,30.735   c0.308-0.012,0.58-0.062,0.898-0.062c1.975,0,4.02,0.136,6.101,0.396l0.118-0.142c-17.786-22.284-43.285-36.375-71.671-36.375   c-51.164,0-93.127,45.528-96.86,103.061c2.243-0.485,4.211-1.064,5.512-1.69C17.511,53.69,56.799,11.484,104.482,11.484z    M47.924,96.105c7.392-30.032,29.932-51.95,56.551-51.95c4.375,0,8.633,0.635,12.735,1.755c3.688,0.946,14.588,5.03,20.144,8.275   c1.064,0.381,1.886,0.913,2.507,1.507c0.674-0.75,1.389-1.472,2.14-2.198c-10.593-9.266-23.525-14.774-37.519-14.774   c-30.627,0-56.286,26.141-62.87,61.085c0.272,0.041,0.532,0.059,0.807,0.106C43.713,98.842,45.602,97.477,47.924,96.105z    M199.11,92.316c-0.591,3.077-1.844,5.929-4.185,7.832c0.804,5.639,1.336,11.384,1.336,17.271c0,22.2-5.899,43.373-17.041,61.401   l-22.81-14.896c0.095-0.142,0.165-0.319,0.271-0.474c-0.591,0.013-1.141,0.048-1.784,0.048c-0.958,0-1.986-0.023-3.074-0.071   l-1.466-0.07c-0.732,1.253-0.384,2.86,0.84,3.664l27.349,17.856c0.461,0.302,0.97,0.438,1.489,0.438   c0.881,0,1.762-0.438,2.282-1.229c12.69-19.422,19.387-42.48,19.387-66.691C201.699,108.778,200.753,100.396,199.11,92.316z    M58.233,162.731c-1.9,0.201-3.939,0.349-6.139,0.414c0.154,0.26,0.287,0.531,0.438,0.78l-3.298,2.151   c0.26,1.785,0.47,3.889,0.603,6.123l7.917-5.166c1.265-0.845,1.617-2.518,0.795-3.771   C58.446,163.086,58.348,162.909,58.233,162.731z M151.835,156.265c0,0-7.695,2.199-3.948-5.271l0.65-2.861   c0,0-8.789,2.648-8.789-2.866c0,0-36.479,12.081-54.06,0.437c0,0-5.491-2.866-6.809,0.656c0,0-0.659,12.307-33.18,11.645   c0,0-2.639-0.42-2.417,4.173c0,0,4.395,19.79-1.978,26.599c-6.375,6.81-8.564,9.008-9.224,4.628l-0.219-5.071   c0,0-2.42-0.881-1.761-9.215c0,0,2.196-1.762,4.619-0.65c0,0,1.971-15.829-1.54-23.087c0,0-5.932-9.883,4.838-10.982   c0,0,7.909,1.974,6.59-3.942c0,0-12.741-16.929-5.054-29.447c0,0-0.883-2.648-4.619,1.117c0,0-30.104,22.833-34.936,3.286   c0,0,14.074-0.815,18.238-5.272c4.454-4.775,13.187-7.477,25.718-4.61c0,0,14.277-14.96,36.697-8.804c0,0,8.727,2.692,18.643,2.35   c-3.215-3.603-8.571-4.347-8.571-4.347c-16.656-3.807-20.46-9.918-20.46-9.918c-5.905-6.328,4.22-14.126,4.22-14.126   c-1.058-0.63-1.894-1.691-1.894-1.691c-3.801-2.317,13.278-4.847,13.278-4.847c-0.943-3.065,27.63-3.166,27.63-3.166   c-1.466-6.537,4.433-9.909,4.433-9.909c12.649-5.29,15.604,7.784,15.604,7.784c4.209-0.201,3.382,2.397,2.577,3.003   c-0.957,0.745-3.937,0.047-4.268,1.215c-0.426,1.537,0.769,5.098-0.213,6.339c-0.33,0.417-1.737,0.63-1.737,0.63   c-1.052,2.208-0.532,3.413-1.146,3.375c-1.253-0.101-6.384-0.417-6.384-0.417c-0.633,2.326-11.396,10.974-11.396,10.974   c0.698,2.506,8.713,2.645,14.08,2.438c3.7-3.774,7.932-8.704,9.871-13.205c3.31-7.646,9.835-18.303,21.526-23.193   c0.077-0.08,0.124-0.178,0.201-0.249c0.674-0.571,1.561-0.78,2.519-0.745c5.331-1.688,11.608-2.246,19.044-0.878l7.034-8.783   l0.213,6.599l4.622-5.062l-2.565,10.988c0,0,4.988,1.756,6.159,27.55c0,0,3.228,15.817-3.807,17.579c0,0-6.064,2.323-8.926-4.602   c-3.215,0.636-7.436,1.339-12.731,1.835c-0.378,3.469-1.312,7.684-3.617,11.036c0,0-1.111,7.689,2.411,10.332   c0,0,3.954,7.252-2.411,12.513c0,0-2.424,3.299,4.397,3.299c0,0,12.081-3.299,11.856,6.164c0,0,5.935,7.685-4.385,12.969   l-9.896,6.158c0,0-4.403,1.975-14.505,1.537L151.835,156.265z M168.315,87.487c0,0,0.124,1.387,0.101,3.414   c4.238-0.405,7.802-0.943,10.651-1.478c-2.329-1.833-7.578-6.608-7.229-12.268C171.837,77.149,168.315,74.292,168.315,87.487z    M160.843,148.581c0,0,6.585,0.438,10.545-7.471C171.388,141.11,162.605,143.746,160.843,148.581z M116.962,93.655h-4.114   l1.218,1.821C115.083,94.944,116.041,94.332,116.962,93.655z"
            data-original="#000000"
            fill="currentColor"
          ></path>
        </svg>
      ),
      id: "horse-racing",
    },

    {
      title: "Greyhound Racing",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "greyhound-racing" && `fill-[white]`
          } relative top-[3px]`}
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="20"
          viewBox="0 0 18 20"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.73413 9.63787C5.4851 8.69782 6.69752 9.6968 6.952 9.95449C5.71704 7.88027 6.88184 5.43246 6.8882 5.41853C5.33932 5.34156 3.6354 5.19601 2.60475 6.35483C0.0332312 9.24785 1.5163 9.42536 1.15894 12.1927C1.00262 13.4025 0.264445 14.3412 0.175013 14.9671C0.0988507 15.4986 -0.0776494 17.9962 0.0385025 18.6177C0.0859449 18.8729 1.10096 18.8009 1.28836 18.818C1.4156 18.041 0.877196 18.0739 0.799034 17.1656C0.572184 14.5333 1.82168 14.8128 2.49823 12.4787C2.71036 12.7064 2.7549 13.1154 2.77216 13.4415C2.79398 13.8367 2.78834 14.1929 2.77435 14.5869C2.37663 14.8726 2.42171 14.6473 2.27447 15.0819C3.95822 15.5611 2.9972 11.7826 3.04282 11.2219C3.07263 10.854 3.18824 10.704 3.32966 10.5538C5.31242 13.0073 3.5376 13.859 3.55578 14.4414C3.72755 14.8455 3.91169 14.9057 4.06092 15.4123C4.17762 15.8096 4.18562 16.1464 4.33067 16.5552C4.64641 17.4481 5.16864 17.7799 6.16856 17.5867C6.02751 16.584 5.45475 17.1211 4.91689 15.9916C4.53607 15.1919 4.46246 14.696 4.84872 13.9938C5.91099 12.0635 5.92863 12.0775 5.73413 9.63733V9.63787ZM8.59249 8.8439H8.11206V7.24613C7.9083 7.35328 7.76143 7.40685 7.54367 7.48418V6.81771C7.79324 6.70396 8.10716 6.53752 8.2344 6.28393L8.28893 6.17678H8.78862V8.8439H8.59249ZM9.63186 11.2287C9.86816 11.2372 10.1166 11.2465 10.3822 11.2671L11.0297 15.2707C11.1024 15.8421 11.1055 17.0154 11.2194 17.4503C11.2862 17.7048 11.459 17.986 11.5412 18.2764C11.6568 18.6819 11.6177 19.0164 11.7593 19.3414C12.1974 19.6093 12.7554 19.8236 13.3356 19.4981C13.3847 19.3886 13.4047 19.3731 13.3242 19.2289C12.8025 18.3182 12.3063 20.1863 11.8915 14.576C11.8582 14.1296 11.7184 12.7761 12.0187 12.3928C11.856 12.1978 11.9505 7.93938 9.6324 11.2287H9.63186ZM13.2551 18.5907C13.3096 18.7041 13.3778 19.0729 13.5009 19.0832C13.6336 19.0954 13.8226 19.1125 13.9553 19.1C14.1409 19.0821 14.57 19.0464 14.6097 18.8448C14.6989 18.6127 14.6824 18.6069 14.5055 18.4114C13.9331 17.7787 13.5439 18.7166 13.4534 15.3471C13.3602 11.8946 13.3731 12.2071 13.7292 10.2517C12.9952 9.80395 12.7869 12.2339 12.0265 12.3993C12.6756 14.246 12.4909 16.9985 13.2551 18.5907ZM13.8155 6.93683L14.5144 3.03411C14.7162 2.8532 16.2658 2.8716 16.9634 2.4805C17.4066 2.23156 17.3633 2.28317 17.44 1.90744C17.4597 1.80922 17.4582 1.83261 17.3639 1.77636C16.3678 1.17972 16.7938 1.80957 15.2917 0.618436C14.0751 -0.345011 10.9241 -0.340547 11.6279 1.77439L12.0231 1.09578C12.4337 1.61367 11.8924 2.49443 11.378 3.70986C11.1536 4.2406 11.0215 4.44508 10.516 4.6767C10.227 4.80903 9.92687 4.94671 9.63077 5.06958L9.63913 5.06619C9.64385 5.07529 10.0319 6.66467 10.9813 7.89366C11.9265 9.11784 13.4312 9.97378 13.9069 8.5187C14.0649 8.03439 13.8342 7.46114 13.8161 6.93611L13.8155 6.93683Z"
            fill="currentColor"
          ></path>
        </svg>
      ),
      id: "greyhound-racing",
    },
    {
      title: "Politics",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "politics" && `fill-[white]`
          } relative top-[3px]`}
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 299.993 299.993"
          xmlSpace="preserve"
        >
          <path
            d="M181.985,124.5l-1.458,0.909l5.004,13.454c0.734,1.973,2.928,2.977,4.9,2.243l21.011-7.814
				c1.973-0.733,2.977-2.927,2.243-4.9l-13.933-37.463c-0.734-1.973-2.928-2.977-4.9-2.243l-7.587,2.822
				c0.646,0.775,1.251,1.6,1.8,2.481C195.534,104.369,192.365,118.029,181.985,124.5z"
          ></path>
          <path
            d="M176.571,115.814c5.584-3.48,7.289-10.828,3.808-16.412c-3.48-5.584-10.828-7.29-16.412-3.808l-17.356,10.819
				c-0.059-11.799-0.046-9.247-0.106-21.107c-0.077-15.469-12.724-28.053-28.192-28.053c-7.243,0-56.063,0-63.958,0
				c-15.468,0-28.116,12.583-28.193,28.052l-0.441,87.524c-0.033,6.579,5.273,11.94,11.853,11.973c0.02,0,0.041,0,0.061,0
				c6.46,0,11.879-5.236,11.912-11.853c0.011-2.148,0.438-87.126,0.44-87.524c0.016-1.266,1.05-2.281,2.315-2.272
				c1.265,0.008,2.286,1.035,2.286,2.301c0.001,29.865,0.005,200.243,0.005,200.243c0,7.896,6.401,14.297,14.296,14.297
				c7.89,0,14.297-6.401,14.297-14.297V171.424h6.172v114.271c0,7.896,6.411,14.297,14.296,14.297
				c7.896,0,14.296-6.401,14.296-14.297c0-53.144-0.246-145.072-0.259-200.244c-0.001-1.372,1.108-2.486,2.479-2.493
				c1.372-0.008,2.492,1.095,2.506,2.467c0.021,4.207,0.192,38.193,0.213,42.446c0.047,9.338,10.349,14.956,18.215,10.05
				L176.571,115.814z"
          ></path>
          <path
            d="M86.434,49.382c13.634,0,24.691-11.053,24.691-24.691C111.125,11.057,100.072,0,86.434,0
				C72.729,0,61.742,11.145,61.742,24.691C61.742,38.328,72.797,49.382,86.434,49.382z"
          ></path>
          <path
            d="M195.204,206.231c-3.565,0-5.572,2.852-5.572,6.432c0,3.521,2.007,6.432,5.606,6.432c3.602,0,5.572-2.913,5.572-6.501
				C200.81,209.012,198.725,206.231,195.204,206.231z"
          ></path>
          <path
            d="M262.432,152.258H147.202c-6.539,0-11.84,5.301-11.84,11.84v101.652c0,6.539,5.301,11.84,11.84,11.84h6.915v17.123
				c0,2.916,2.364,5.28,5.28,5.28h11.54c2.916,0,5.28-2.364,5.28-5.28v-17.123h57.2v17.123c0,2.916,2.364,5.28,5.28,5.28h11.54
				c2.916,0,5.28-2.364,5.28-5.28v-17.123h6.915c6.539,0,11.84-5.301,11.84-11.84V164.098
				C274.272,157.559,268.971,152.258,262.432,152.258z M174.291,224.839h-5.572l-9.081-24.421h7.085l4.781,15.993l4.712-15.993
				h7.051L174.291,224.839z M195.169,225.046c-7.152,0-12.348-5.944-12.348-12.451c0-6.523,5.3-12.314,12.486-12.314
				c7.307,0,12.313,6.072,12.313,12.451C207.62,219.206,202.319,225.046,195.169,225.046z M229.117,206.265H222.1v18.574h-6.707
				v-18.574h-7.051v-5.847h20.775V206.265z M248.964,224.839L248.964,224.839h-17.405v-24.421h17.095v5.847h-10.387v3.44h8.874
				v5.434h-8.874v3.853h10.697V224.839z"
          ></path>
        </svg>
      ),
      id: "politics",
    },
    {
      title: "Lottery",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "lottery" && `fill-[white]`
          } relative top-[3px]`}
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 511.999 511.999"
          xmlSpace="preserve"
        >
          <path
            fill="currentColor"
            d="M319.437,486.683l-6.2-106.699h-47.931l6.361,109.475c0.772,13.295,12.209,23.278,25.273,22.497
			C310.132,511.19,320.204,499.875,319.437,486.683z"
          ></path>
          <path
            fill="currentColor"
            d="M398.141,103.704l-36.204-91.121C357.87,2.35,346.28-2.654,336.046,1.416c-10.233,4.065-15.233,15.657-11.167,25.891
			L353.4,99.092l-47.807,16.67H288.93v-0.001c-0.08-0.134-0.161-0.269-0.243-0.402l-0.154,0.402
			c-5.986,15.638-11.314,29.557-24.365,63.655h43.764v-23.778c0,0,38.461-12.047,78.244-25.745
			C396.884,126.158,402.328,114.243,398.141,103.704z"
          ></path>
          <path
            fill="currentColor"
            d="M268.807,147.216l-8.002-14.555l7.114-12.939c1.059-1.926-0.337-4.292-2.538-4.292h-19.527
			c-2.198,0-3.599,2.362-2.538,4.292l7.114,12.939l-8.032,14.608c-0.931,1.693-1.236,3.663-0.859,5.558l5.095,25.663
			c-2.561-6.57-21.695-55.638-24.461-62.732h-21.752c-6.603,0-12.778,3.269-16.49,8.73l-29.957,44.073l-3.847-7.603
			c-4.975-9.832-17.007-13.738-26.792-8.79c-9.284,4.701-14.114,16.265-8.558,27.246h80.039l7.506-11.044v11.044h44.495h17.193
			l5.633-26.534C270.054,150.954,269.757,148.943,268.807,147.216z"
          ></path>
          <path
            fill="currentColor"
            d="M255.619,19.944c-22.821,0-41.322,18.5-41.322,41.322c0,22.86,18.564,41.322,41.322,41.322
			c22.6,0,41.322-18.318,41.322-41.322C296.941,38.445,278.44,19.944,255.619,19.944z"
          ></path>
          <path
            fill="currentColor"
            d="M197.461,379.984l-6.201,106.699c-0.796,13.694,10.078,25.314,23.907,25.314c12.579,0,23.125-9.82,23.864-22.538
			l6.361-109.475H197.461z"
          ></path>
          <path
            fill="currentColor"
            d="M388.625,279.388v8.243c2.091-0.492,3.752-1.661,3.752-3.876C392.377,281.726,390.84,280.432,388.625,279.388z"
          ></path>
          <path
            fill="currentColor"
            d="M381.242,264.13c0,1.784,1.599,2.891,3.937,3.875v-7.32C382.412,261.24,381.242,262.655,381.242,264.13z"
          ></path>
          <path
            fill="currentColor"
            d="M341.967,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
			c3.398,0,5.462-1.88,5.462-6.068v-16.082C347.429,262.2,345.366,260.319,341.967,260.319z"
          ></path>
          <path
            fill="currentColor"
            d="M307.44,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068c3.398,0,5.462-1.88,5.462-6.068
			v-16.082C312.902,262.2,310.838,260.319,307.44,260.319z"
          ></path>
          <path
            fill="currentColor"
            d="M157.258,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
			c3.398,0,5.462-1.88,5.462-6.068v-16.082C162.719,262.2,160.656,260.319,157.258,260.319z"
          ></path>
          <path
            fill="currentColor"
            d="M191.785,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
			c3.398,0,5.462-1.88,5.462-6.068v-16.082C197.247,262.2,195.183,260.319,191.785,260.319z"
          ></path>
          <path
            fill="currentColor"
            d="M272.913,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.003,6.068,5.401,6.068
			c3.398,0,5.462-1.88,5.462-6.068v-16.082C278.376,262.2,276.312,260.319,272.913,260.319z"
          ></path>
          <path
            fill="currentColor"
            d="M226.311,260.319c-3.399,0-5.401,1.881-5.401,6.07v16.082c0,4.188,2.002,6.068,5.401,6.068
			c3.398,0,5.462-1.88,5.462-6.068v-16.082C231.774,262.2,229.71,260.319,226.311,260.319z"
          ></path>
          <path
            fill="currentColor"
            d="M417.878,196.084H94.121c-8.743,0-15.831,7.087-15.831,15.831v134.46c0,8.743,7.087,15.832,15.831,15.832h323.758
			c8.743,0,15.831-7.087,15.831-15.832v-134.46C433.71,203.171,426.621,196.084,417.878,196.084z M120.12,296.427
			c-2.367,0-4.734-0.971-4.734-2.913v-30.889l-1.759,1.091c-3.556,2.372-6.515-4.22-2.731-6.494l8.01-4.854
			c0.486-0.303,1.092-0.426,1.76-0.426c1.942,0,4.187,1.153,4.187,2.974v38.598h0.001
			C124.854,295.456,122.487,296.427,120.12,296.427z M134.016,296.792c-2.67,0-4.673-2.186-4.673-4.673
			c0-2.549,2.002-4.673,4.673-4.673c2.488,0,4.613,2.124,4.613,4.673C138.629,294.606,136.504,296.792,134.016,296.792z
			 M172.186,282.469c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082
			c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z M206.713,282.469
			c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323
			c8.374,0,14.928,3.884,14.928,14.323V282.469z M241.241,282.469c0,10.439-6.554,14.323-14.928,14.323
			c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z
			 M249.671,296.792c-2.67,0-4.673-2.186-4.673-4.673c0-2.549,2.002-4.673,4.673-4.673c2.488,0,4.612,2.124,4.612,4.673
			C254.284,294.606,252.161,296.792,249.671,296.792z M287.842,282.469c0,10.439-6.554,14.323-14.928,14.323
			c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z
			 M322.369,282.469c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082
			c0-10.439,6.493-14.323,14.868-14.323c8.374,0,14.928,3.884,14.928,14.323V282.469z M356.896,282.469
			c0,10.439-6.554,14.323-14.928,14.323c-8.375,0-14.868-3.884-14.868-14.323v-16.082c0-10.439,6.493-14.323,14.868-14.323
			c8.374,0,14.928,3.884,14.928,14.323V282.469z M389.24,296.181v1.784c0,0.861-1.169,1.661-2.338,1.661
			c-1.353,0-2.338-0.8-2.338-1.661v-1.538c-7.382-0.247-13.41-4.059-13.41-7.997c0-2.092,1.846-5.167,4.183-5.167
			c2.584,0,4.676,3.629,9.228,4.428v-9.966c-5.66-2.154-12.304-4.798-12.304-12.673c0-7.812,5.783-11.565,12.304-12.487v-1.722
			c0-0.861,0.985-1.661,2.338-1.661c1.169,0,2.338,0.8,2.338,1.661v1.538c3.814,0.122,11.011,1.107,11.011,5.352
			c0,1.66-1.107,5.044-3.814,5.044c-2.03,0-3.198-1.968-7.197-2.277v8.982c5.598,2.091,12.119,4.983,12.119,13.287
			C401.359,290.399,396.437,295.013,389.24,296.181z"
          ></path>
        </svg>
      ),
      id: "lottery",
    },
    {
      title: "Live Casino",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "live-casino" && `fill-[white]`
          } relative top-[3px]`}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 309.51 309.51"
          xmlSpace="preserve"
        >
          <path d="M99.177,276.448V175.913c0-2.383-1.582-3.724-2.302-4.175c-1.638-1.026-3.021-1.993-4.052-2.861     c-4.252-3.578-7.789-7.87-9.359-14.425c-2.78-11.602,3.309-23.667,14.744-27.062c0.174-0.052,0.969-0.271,0.969-1.937V44.048     c0-9.165,4.141-17.376,10.646-22.875c0.654-0.555,1.666-1.632-1.039-0.665l-95.8,28.445c-9.573,2.842-15.078,13-12.236,22.573     l66.151,222.785c2.843,9.573,13,15.079,22.573,12.238l15.854-4.708c5.236-1.835,1.128-5.833,1.693-5.214     C102.151,291.302,99.177,284.218,99.177,276.448z M55.95,74.698c-1.432,4.742-9.86,17.511-12.295,18.234     c-2.383,0.708-16.527-5.396-20.286-8.561c-1.882-1.583-3.448-3.484-4.144-6.385c-1.23-5.135,1.664-10.538,6.727-12.041     c5.204-1.545,9.883,3.108,10.538,2.914c0.748-0.222,2.259-6.714,7.239-8.192c5.063-1.503,10.436,1.445,12.207,6.418     C56.938,69.897,56.663,72.335,55.95,74.698z"></path>
          <path d="M187.159,14.092c3.253,0,2.324-1.439,1.97-2.116c-3.937-7.531-12.81-11.519-21.245-9.014L133.945,13.04     c0,0-3.183,1.052,0.448,1.052C148.312,14.092,187.159,14.092,187.159,14.092z"></path>
          <path d="M292.455,37.536H140.67c-9.381,0-17.056,7.675-17.056,17.056v214.04c0,9.38,7.675,17.055,17.056,17.055h151.785     c9.38,0,17.055-7.675,17.055-18.762V54.592C309.51,46.918,301.835,37.536,292.455,37.536z M172.477,72.206     c-2.557,3.887-13.561,13.131-15.946,13.131c-2.336,0-13.44-9.277-15.98-13.131c-1.271-1.93-2.173-4.059-2.022-6.858     c0.265-4.953,4.315-9.044,9.275-9.044c5.101,0,8.069,5.441,8.711,5.441c0.732,0,3.829-5.441,8.709-5.441     c4.963,0,9.012,4.091,9.277,9.044C174.651,68.147,173.751,70.268,172.477,72.206z M252.625,165.168     c-5.774,8.783-30.636,29.667-36.025,29.667c-5.276,0-30.364-20.96-36.101-29.667c-2.872-4.359-4.91-9.169-4.573-15.492     c0.6-11.19,9.751-20.434,20.958-20.434c11.522,0,18.231,12.293,19.68,12.293c1.654,0,8.651-12.293,19.678-12.293     c11.209,0,20.359,9.244,20.957,20.434C257.536,155.998,255.505,160.79,252.625,165.168z M294.598,258.322     c-0.261,4.885-4.256,8.921-9.148,8.921c-5.029,0-7.958-5.368-8.591-5.368c-0.723,0-3.776,5.368-8.59,5.368     c-4.894,0-8.888-4.036-9.149-8.921c-0.147-2.76,0.74-4.851,1.996-6.763c2.521-3.834,13.374-12.951,15.728-12.951     c2.303,0,13.254,9.149,15.759,12.951C293.857,253.463,294.746,255.563,294.598,258.322z"></path>
        </svg>
      ),
      id: "live-casino",
    },
    {
      title: "Virtual Sports",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "virtual-sports" && `fill-[white]`
          } relative top-[3px]`}
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_5"
          enableBackground="new 0 0 64 64"
          height="512px"
          viewBox="0 0 64 64"
          width="512px"
        >
          <path
            d="m17.002 3c-1.841 0-3.59.74-4.883 2h9.764c-1.292-1.26-3.04-2-4.881-2z"
            data-original="#000000"
          ></path>
          <path
            d="m25.002 43.794v6.408c3.794-.835 6-2.167 6-3.202 0-.805-1.629-2.257-6-3.206z"
            data-original="#000000"
          ></path>
          <path
            d="m36.279 13.461c-.814-.677-2.135-.556-2.813.259l-5.387 6.248-7.151-.969h-3.903c-.008 0-.015.001-.023.001s-.015-.001-.023-.001h-2.978c-3.859.001-6.999 3.141-6.999 7v2.772c0 2.331 1.896 4.229 4.228 4.229.829 0 1.634-.241 2.327-.697l5.251-3.458c.521-.3.868-.662 1.031-1.054.249-.598.213-1.23-.104-1.784-.529-.924-1.816-1.271-2.724-.745l-4.738 3.22c-.497.339-1.08.519-1.686.519h-1.587v-2h1.588c.202 0 .396-.06.561-.172l4.802-3.26c2.018-1.176 4.463-.404 5.521 1.446.622 1.089.699 2.381.213 3.547-.337.809-.971 1.495-1.832 1.986l-5.196 3.425c-1.021.672-2.206 1.027-3.427 1.027-.077 0-.151-.009-.228-.012v15.582c1.494.226 3.171.372 5 .412v-13.325c0-1.336.52-2.592 1.464-3.536l.829-.829 1.414 1.416-.829.828c-.566.565-.878 1.319-.878 2.121v13.326c1.829-.041 3.506-.187 5-.412v-26.572l4.984.006h.006c1.238 0 2.41-.54 3.215-1.482l5.34-6.252c.697-.838.581-2.103-.268-2.81z"
            data-original="#000000"
          ></path>
          <path
            d="m10.002 11h3.764c.382 0 .725-.212.895-.553.444-.892 1.342-1.447 2.341-1.447.998 0 1.896.555 2.341 1.448.17.34.513.552.895.552h3.765c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-14c-.552 0-1 .448-1 1v2c-.001.552.447 1 .999 1z"
            data-original="#000000"
          ></path>
          <path
            d="m17.554 11.342c-.208-.419-.896-.417-1.104-.001-.513 1.023-1.541 1.659-2.684 1.659h-3.066c1.136 2.407 3.548 4 6.302 4s5.165-1.593 6.301-4h-3.066c-1.143 0-2.172-.636-2.683-1.658z"
            data-original="#000000"
          ></path>
          <path
            d="m9.002 50.202v-6.408c-4.371.949-6 2.401-6 3.206 0 1.036 2.206 2.367 6 3.202z"
            data-original="#000000"
          ></path>
          <path
            d="m3.002 50.056v.944c0 1.631 5.454 4 14 4s14-2.369 14-4v-.944c-2.879 1.94-8.459 2.944-14 2.944s-11.121-1.004-14-2.944z"
            data-original="#000000"
          ></path>
          <path d="m37 7h20v4h-20z" data-original="#000000"></path>
          <path
            d="m33 3v8.561c.601-.349 1.282-.56 2-.56v-6.001h24v8h-20.551c.816 1.412.728 3.237-.372 4.56l-5.077 5.943v3.497h28v-24zm4 22h-2v-2h2zm8 0h-6v-2h6zm0-4h-6v-2h6zm0-4h-4v-2h4zm14 8h-12v-10h12z"
            data-original="#000000"
          ></path>
          <path d="m49 17h8v6h-8z" data-original="#000000"></path>
          <path
            d="m3.002 54.056v2.944c0 1.631 5.454 4 14 4s14-2.369 14-4v-2.944c-2.879 1.94-8.459 2.944-14 2.944s-11.121-1.004-14-2.944z"
            data-original="#000000"
          ></path>
          <path
            d="m39 33v10h4.697l6-4h5.803l4.5-6z"
            data-original="#000000"
          ></path>
          <path d="m39 45h4v4h-4z" data-original="#000000"></path>
          <path d="m51 41h4v8h-4z" data-original="#000000"></path>
          <path d="m57 49h4v-14l-4 5.333z" data-original="#000000"></path>
          <path d="m45 49h4v-7.132l-4 2.667z" data-original="#000000"></path>
        </svg>
      ),
      id: "virtual-sports",
    },
    {
      title: "Tips & Previews",
      svg: (
        <svg
          className={`w-[32px] h-[29px] ${
            selectedGame == "tips&previews" && `fill-[white]`
          } relative top-[3px]`}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="32px"
          height="29px"
          viewBox="0 0 32 29"
          xmlSpace="preserve"
        >
          <path d="M30.289,6.177c0-1.69-0.608-3.133-1.82-4.333c-1.206-1.194-2.67-1.786-4.378-1.786H7.909    c-1.708,0-3.172,0.592-4.384,1.786c-1.206,1.2-1.814,2.643-1.814,4.333v10.524c0,1.69,0.608,3.133,1.814,4.333    c1.211,1.194,2.676,1.792,4.384,1.792h4.073c-0.248,1.657-1.116,3.178-2.603,4.564c-0.473,0.406-0.529,0.845-0.169,1.324    c0.333,0.305,0.851,0.305,1.549,0c3.77-1.104,6.75-3.064,8.948-5.888h4.383c1.708,0,3.172-0.598,4.378-1.792    c1.212-1.2,1.82-2.643,1.82-4.333V6.177z"></path>
          <path
            fill="#F9E665"
            d="M16.806,5.32l-0.034-1.285c-0.006-0.169-0.073-0.315-0.192-0.428c-0.124-0.118-0.271-0.169-0.44-0.164l0,0    c-0.168,0-0.314,0.068-0.427,0.186c-0.119,0.125-0.175,0.271-0.169,0.439l0.04,1.285c0,0.168,0.067,0.31,0.186,0.428    c0.124,0.113,0.27,0.168,0.439,0.164h0.006c0.163,0,0.31-0.068,0.422-0.192C16.75,5.636,16.806,5.49,16.806,5.32z"
          ></path>
          <path
            fill="#F9E665"
            d="M21.105,5.382c-0.169,0.005-0.311,0.067-0.428,0.192l-0.885,0.924c-0.119,0.119-0.174,0.265-0.174,0.433    c0.005,0.169,0.067,0.311,0.185,0.429h0.006c0.119,0.118,0.265,0.174,0.434,0.168c0.169,0,0.31-0.062,0.428-0.186l0.891-0.924    c0.112-0.118,0.168-0.265,0.168-0.434c-0.006-0.169-0.067-0.31-0.186-0.428h-0.005C21.42,5.439,21.273,5.382,21.105,5.382z"
          ></path>
          <path
            fill="#F9E665"
            d="M23.105,9.546l-1.234,0.338c-0.164,0.045-0.287,0.141-0.366,0.287c-0.084,0.146-0.101,0.304-0.057,0.462    v0.006c0.045,0.164,0.141,0.281,0.288,0.366c0.146,0.079,0.299,0.101,0.462,0.056l1.234-0.343    c0.163-0.045,0.287-0.141,0.366-0.287c0.085-0.147,0.102-0.299,0.057-0.462l0,0c-0.045-0.164-0.141-0.288-0.287-0.372    C23.42,9.518,23.269,9.496,23.105,9.546z"
          ></path>
          <path
            fill="#F9E665"
            d="M21.189,13.625c-0.135,0.107-0.215,0.236-0.231,0.406v0.006c-0.028,0.164,0.012,0.315,0.119,0.445    c0.102,0.135,0.236,0.213,0.406,0.236l1.262,0.169c0.169,0.017,0.321-0.022,0.457-0.125c0.129-0.101,0.209-0.236,0.226-0.4    l0.006-0.006c0.017-0.163-0.022-0.315-0.119-0.451c-0.107-0.129-0.242-0.208-0.406-0.23l-1.268-0.169    C21.471,13.484,21.325,13.523,21.189,13.625z"
          ></path>
          <path
            fill="#F9E665"
            d="M10.106,5.968c-0.006,0.169,0.051,0.315,0.169,0.439l0.89,0.924c0.113,0.118,0.26,0.18,0.428,0.186    c0.164,0,0.311-0.057,0.434-0.169V7.343c0.124-0.113,0.186-0.26,0.192-0.428c0-0.164-0.057-0.31-0.175-0.434l-0.884-0.924    c-0.119-0.118-0.266-0.186-0.428-0.186c-0.169-0.006-0.316,0.056-0.44,0.169v0.005C10.174,5.658,10.106,5.805,10.106,5.968z"
          ></path>
          <path
            fill="#F9E665"
            d="M8.202,10.414c0.084,0.152,0.208,0.248,0.372,0.293l1.234,0.338c0.157,0.045,0.315,0.029,0.456-0.056    c0.152-0.08,0.248-0.203,0.293-0.361v-0.006c0.045-0.164,0.022-0.315-0.056-0.467c-0.085-0.141-0.208-0.237-0.366-0.282    L8.901,9.529C8.737,9.484,8.58,9.501,8.433,9.585C8.287,9.664,8.191,9.789,8.151,9.952v0.006    C8.101,10.115,8.123,10.272,8.202,10.414z"
          ></path>
          <path
            fill="#F9E665"
            d="M10.174,14.701c0.164-0.022,0.299-0.101,0.401-0.231c0.106-0.135,0.146-0.281,0.124-0.451l0,0    c-0.023-0.169-0.102-0.305-0.237-0.406c-0.129-0.101-0.281-0.141-0.451-0.119l-1.262,0.169c-0.168,0.017-0.304,0.096-0.405,0.231    c-0.101,0.129-0.141,0.287-0.118,0.451v0.006c0.017,0.163,0.096,0.292,0.23,0.394c0.13,0.107,0.282,0.147,0.451,0.124    L10.174,14.701z"
          ></path>
          <path
            fill="#F9E665"
            d="M16.006,7.433c-1.178,0-2.186,0.423-3.02,1.273c-0.834,0.846-1.251,1.871-1.251,3.071     c0,1.082,0.344,2.022,1.026,2.823c0.461,0.603,0.789,1.278,0.968,2.022l3.978-0.226c0.35-0.485,0.71-0.93,1.087-1.335     c0.079-0.068,0.152-0.14,0.231-0.214c0.833-0.851,1.251-1.876,1.251-3.071c0-1.2-0.417-2.225-1.251-3.071     C18.192,7.856,17.188,7.433,16.006,7.433z"
          ></path>
          <path
            fill="#F9E665"
            d="M14.293,18.78c0.315,0.423,0.8,0.654,1.442,0.688c0.637-0.09,1.122-0.377,1.449-0.862L14.293,18.78z"
          ></path>
          <path
            fill="#F9E665"
            d="M13.825,17.26c0.018,0.332,0.068,0.625,0.147,0.885l3.538-0.226c0.045-0.146,0.08-0.304,0.113-0.468     c0.011-0.141,0.022-0.287,0.028-0.428L13.825,17.26z"
          ></path>
        </svg>
      ),
      id: "tips&previews",
    },
  ];

  const [casino, setCasino] = useState(Appconfig.allCasino);
  // useEffect(() => (
  //     setCasino(activeCasino == 'popular' ?  Appconfig.allCasino : Appconfig.allCasino.filter(e => e.category == activeCasino))
  // ), [activeCasino])

  useEffect(() => {
    if (activeCasino == "popular") {
      const filteredCasinos =
        // Appconfig.sitecodes != "P32"
        Appconfig.sitecodes != "P56"
          ? Appconfig.allCasino.filter((e) => e.casino_type != "WCO")
          : Appconfig.allCasino;
      setCasino(filteredCasinos);
    } else {
      setCasino(Appconfig.allCasino.filter((e) => e.category == activeCasino));
    }
  }, [activeCasino]);

  const scrollableGamesListRef = useRef(null);
  const scrollGame = (index) => {
    const itemElement = scrollableGamesListRef.current.querySelector(
      `#item-${index}`,
    );
    if (itemElement) {
      itemElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  const scrollableDivRef = useRef(null);
  const scrollToItem = (index) => {
    const itemElement = scrollableDivRef.current.querySelector(
      `#item-${index}`,
    );
    if (itemElement) {
      itemElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  const handleSelectGame = (game, index) => {
    if (game.id == "live-casino") {
      navigate("/live-casino");
    }
    if (game.id == "virtual-sports") {
      navigate("/virtual-sports");
    }
    if (game.id == "tips&previews") {
      navigate("/tips-previews");
    }
    setSelectedGame(game.id);
    setEventType(game.id);
    scrollGame(index);
  };

  useEffect(() => {
    dispatch(
      getAllEvents({
        user_id: userInfo ? userInfo._id : "",
      }),
    );
  }, []);

  useEffect(() => {
    if (userInfo) {
      dispatch(
        getLoginUser({
          user_id: userInfo ? userInfo._id : "",
        }),
      );
    }
  }, [userInfo?._id]);

  useEffect(() => {
    const handleMessage = (data) => {
      if (data.action == "USER_BLOCK_UPDATE") {
        let market = data.data;
        console.log("user block Details SOCKET RESPONDING");
        if (market) {
          dispatch(
            getLoginUser({
              user_id: userInfo ? userInfo._id : "",
            }),
          );
        }
      }

      if (data.action == "USER_EVENT_ACTION") {
        let market = data.data;
        if (market) {
          if (market.type == "event") {
            dispatch(
              getAllEvents({
                user_id: userInfo ? userInfo._id : "",
              }),
            );
          }
        }
      }
    };

    WebSocketEventEmitter.on("message", handleMessage);

    return () => {
      WebSocketEventEmitter.off("message", handleMessage); // Cleanup on unmount
    };
  }, [userInfo, dispatch]);

  // useEffect(() => {
  //     if (userInfos.events.length) {
  //         const newEvents = userInfos?.events[0]?.competitions[0]?.events || [];
  //         setIsEventLoading(false);
  //         if (newEvents.length > 0 && (allEvents.length == 0 || JSON.stringify(newEvents) !== JSON.stringify(allEvents))) {
  //             setAllEvents(newEvents);
  //         }
  //     }
  // }, [userInfos.events.length])

  useEffect(() => {
    const events = userInfos?.events;

    if (Array.isArray(events) && events.length > 0) {
      const newEvents = events[0]?.competitions?.[0]?.events || [];
      setIsEventLoading(false);

      if (
        newEvents.length > 0 &&
        (allEvents.length === 0 ||
          JSON.stringify(newEvents) !== JSON.stringify(allEvents))
      ) {
        setAllEvents(newEvents);
      }
    }
  }, [userInfos?.events]);

  useEffect(() => {
    dispatch(
      getBanner({
        site_code: Appconfig.sitecodes,
      }),
    );
    // getBanner();
  }, []);

  // function getBanner() {
  //     var data = JSON.stringify({
  //         site_code: Appconfig.sitecodes
  //     });

  //     var config = {
  //         method: "post",
  //         url: `${Appconfig.apiUrl}banner/getDashboardBanner`,
  //         headers: {
  //             "Content-Type": "application/json",
  //         },
  //         data: data,
  //     };

  //     axios(config)
  //         .then(function (response) {
  //             if (response.data.result) {
  //                 setBanners(response.data.resultData)
  //             }
  //             else {
  //                 console.log(response)
  //             }
  //         })
  //         .catch(function (error) {
  //             console.log(error);
  //         });
  // }

  const filteredEvents = useMemo(() => {
    if (allEvents.length > 0) {
      return allEvents.filter((event) => event.event_type == eventType);
    }
    return [];
  }, [allEvents, eventType]);

  useEffect(() => {
    setEvents(filteredEvents);
  }, [filteredEvents]);

  const [user_nameValidationError, setUser_NameValidationError] = useState(
    "Please enter old password",
  );
  const [passwordValidationError, setPasswordValidationError] = useState(
    "Please enter new password",
  );
  const [conpasswordValidationError, setConPasswordValidationError] = useState(
    "Please check your confirm password",
  );

  const [formData, setformData] = useState({
    user_id: userInfo?._id,
    name: userInfo?.name,
    user_name: userInfo?.user_name,
    user_type: userInfo?.user_type,
    old_password: "",
    new_password: "",
    con_password: "",
  });
  function checkValidation() {
    if (formData.old_password.trim() === "") {
      setUser_NameValidationError("Please enter old password");
      document.querySelector(".oldpassword-error").classList.remove("hidden");
      // console.log('hlw');
    }
    if (formData.new_password.trim() === "") {
      setPasswordValidationError("Please enter new password");
      document.querySelector(".newpassword-error").classList.remove("hidden");
    }
    if (formData.con_password.trim() !== formData.new_password.trim()) {
      document.querySelector(".conpassword-error").classList.remove("hidden");
      setConPasswordValidationError("Please check your confirm password");
    }

    if (
      formData.old_password !== "" &&
      formData.new_password !== "" &&
      formData.con_password !== "" &&
      formData.new_password === formData.con_password
    ) {
      return true;
    }
    return false;
  }

  function setOldPassword(value) {
    setformData({
      ...formData,
      old_password: value,
    });
  }

  function setNewPassword(value) {
    setformData({
      ...formData,
      new_password: value,
    });
  }

  function setConPassword(value) {
    setformData({
      ...formData,
      con_password: value,
    });
  }

  const changePassword = async () => {
    if (checkValidation()) {
      formData.master_id = userInfo?.master_id;
      formData.masters = userInfo?.masters;

      setLoading(true);

      // console.log('formData', formData);
      // return false;
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}users/auraChangePassword`,
        headers: {
          "Content-Type": "application/json",
        },

        data: JSON.stringify(formData),
      };
      axios(config)
        .then(function (response) {
          if (response.data.result) {
            NotificationManager.success(response.data.message, "", 3000);
            formData.old_password = "";
            formData.new_password = "";
            formData.con_password = "";

            dispatch(
              getLoginUser({
                user_id: userInfo ? userInfo._id : "",
              }),
            );

            setChangePassModal(false);
          } else {
            NotificationManager.error(response.data.message, "", 3000);
          }
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const handleCasinoLaunch = async (provider_code, game_code, type) => {
    if (!userInfo || !userInfo._id) {
      setShowLoginModal(true);
      return;
    }

    // Initialize Loader
    setIsLoading(true);
    setShowClose(false);
    setProgress(0);

    // Start progress animation
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return 95; // Slow down near the end if internet is slow
        return prev + 5;
      });
    }, 100);

    try {
      // Perform API call
      const result = await CreateAndLaunchWCOCasino(
        provider_code,
        game_code,
        type,
      );

      // STOP EVERYTHING the moment API responds
      clearInterval(interval);

      if (result && result.success) {
        // Success: Force progress to 100 and close immediately
        setProgress(100);
        setIsLoading(false);
      } else {
        // Error: Stop at current percentage and show X
        setShowClose(true);
      }
    } catch (error) {
      clearInterval(interval);
      setShowClose(true);
    }
  };

  async function CreateAndLaunchWCOCasino(
    provider_code,
    game_code,
    type = null,
  ) {
    if (Appconfig.sitecodes !== "P56") return { success: false };

    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: window.location.hostname,
      provider_code,
      game_code,
      type,
    };

    try {
      const response = await axios.post(
        `${Appconfig.apiUrl}wco/login`,
        userData,
        {
          timeout: 15000, // If internet is very slow, stop waiting after 15 seconds
        },
      );

      const status = response.data.status?.code;

      if (status === "SUCCESS") {
        window.open(response.data.launchURL, "_self");
        return { success: true };
      } else {
        NotificationManager.error(
          response.data.status?.message || "Game Not Found",
          "",
          2000,
        );
        return { success: false };
      }
    } catch (error) {
      if (error.code === "ECONNABORTED") {
        NotificationManager.error(
          "Connection timeout. Please check your internet.",
          "",
          3000,
        );
      }
      return { success: false };
    }
  }

  // Inside Home component:
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showClose, setShowClose] = useState(false); // New state for cross button

  const closeLoader = () => {
    setIsLoading(false);
    setShowClose(false);
    setProgress(0);
  };

  // Effect to handle the counter logic
  // useEffect(() => {
  //   let interval;
  //   if (isLoading) {
  //     setProgress(0);
  //     interval = setInterval(() => {
  //       setProgress((prev) => {
  //         if (prev >= 100) {
  //           clearInterval(interval);
  //           return 100;
  //         }
  //         return prev + 1;
  //       });
  //     }, 30); // Speed: 30ms per 1% (approx 3 seconds total)
  //   }
  //   return () => clearInterval(interval);
  // }, [isLoading]);

  // Your updated function
  const handleCasinoLaunch_old = (provider_code, game_code, type) => {
    if (!userInfo || !userInfo._id) {
      setShowLoginModal(true);
      return;
    }

    setIsLoading(true);

    // Trigger the launch
    CreateAndLaunchWCOCasino(provider_code, game_code, type);

    // Optional: Auto-close loader after it reaches 100% (approx 3.5s)
    setTimeout(() => {
      setIsLoading(false);
    }, 3500);
  };

  // const overlayStyle = {
  //   position: "fixed",
  //   top: 0,
  //   left: 0,
  //   right: 0,
  //   bottom: 0,
  //   backgroundColor: "rgba(0, 0, 0, 0.9)",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   zIndex: 9999,
  // };

  // const containerStyle = {
  //   position: "relative",
  //   display: "flex",
  //   flexDirection: "column",
  //   justifyContent: "center",
  //   alignItems: "center",
  // };

  // const textStyle = {
  //   position: "absolute",
  //   color: "#fff",
  //   fontSize: "20px",
  //   fontWeight: "bold",
  //   fontFamily: "sans-serif",
  // };

  return (
    <>
      <NotificationContainer />
      {userInfo && userInfo?.is_password_update !== "Yes" && (
        <Modal
          className={`password-model relative top-1 lg:top-7 lg:!w-[34vw]`}
          footer={[
            <div className="col-span-12 gap-2 flex flex-shrink-0 flex-wrap items-center justify-end p-[1rem] border-t-[1px] border-t-[#dee2e6]">
              <button
                type="submit "
                className="text-white bg-[#1c272d] hover:!bg-transparent hover:text-inherit border-[1px] border-[#1c272d]   text-[.875rem] rounded-[.25rem] px-[10px] py-[5px]   "
                onClick={() => changePassword()}
              >
                Confirm
              </button>
            </div>,
          ]}
          mask={false}
          open={changePassModal}
        >
          <div className="grid grid-cols-12">
            <div className="col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-t-[5px] h-[35px] bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)] text-[#ffffff] flex flex-shrink-0 items-center justify-between">
              <h5 className="text-[0.938rem] font-bold mb-0 leading-normal">
                Change Password
              </h5>
            </div>
            <div className="col-span-12 !bg-[#ffffff] !text-[#23282c] relative flex-auto p-4">
              <div className="grid grid-cols-12 lg:gap-x-6 ">
                <div className="col-span-12 lg:col-span-6">
                  <div className="mb-4 !text-[#23282c]">
                    <label
                      className="inline-block mb-[.5rem] !text-[#23282c]"
                      for="oldPassword"
                    >
                      Old Password{" "}
                    </label>
                    <div className="relative flex flex-wrap items-stretch w-full text-[#23282c]">
                      <Input.Password
                        id="oldPassword"
                        name="oldPassword"
                        onChange={(e) => setOldPassword(e.target.value)}
                        required
                        className="antd-password"
                        placeholder="Old Password.."
                      />
                      <span className="absolute top-[25px] oldpassword-error hidden  text-[0.813rem] text-[red] leading-[14px]">
                        <div className="leading-[38px] ">
                          {user_nameValidationError}
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-6">
                  <div className="mb-4 !text-[#23282c]">
                    <label
                      className="inline-block mb-[.5rem] !text-[#23282c]"
                      for="newPassword"
                    >
                      New Password{" "}
                    </label>
                    <div className="relative flex flex-wrap items-stretch w-full text-[#23282c]">
                      <Input.Password
                        id="newPassword"
                        name="newPassword"
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        className="antd-password"
                        pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&]{8,}$"
                        placeholder="New Password.."
                      />
                      <span className="absolute top-[25px] newpassword-error hidden  text-[0.813rem] text-[red] leading-[14px]">
                        <div className="leading-[38px] ">
                          {passwordValidationError}
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-6">
                  <div className="mb-4 !text-[#23282c]">
                    <label
                      className="inline-block mb-[.5rem] !text-[#23282c]"
                      for="confirmPass"
                    >
                      Confirm Password{" "}
                    </label>
                    <div className="relative flex flex-wrap items-stretch w-full text-[#23282c]">
                      <Input.Password
                        id="confirmPass"
                        name="confirmPass"
                        onChange={(e) => setConPassword(e.target.value)}
                        required
                        className="antd-password"
                        placeholder="Confirm Password.."
                      />
                      <span className="absolute top-[25px] conpassword-error hidden  text-[0.813rem] text-[red] leading-[14px]">
                        <div className="leading-[38px] ">
                          {conpasswordValidationError}
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* --- FULL SCREEN LOADER OVERLAY --- */}
      {isLoading && (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/60 backdrop-blur-[3px] transition-all duration-500">
          <style>{`
            @keyframes circlePulse {
              0% { transform: scale(1); opacity: 1; stroke-width: 5; }
              50% { transform: scale(1.05); opacity: 0.7; stroke-width: 7; }
              100% { transform: scale(1); opacity: 1; stroke-width: 5; }
            }
            .animate-circle-pulse {
              animation: circlePulse 1.5s infinite ease-in-out;
            }
          `}</style>

          {/* CROSS BUTTON (Shows on failure or if manually triggered) */}
          {showClose && (
            <button
              onClick={closeLoader}
              className="absolute top-10 right-10 w-12 h-12 flex items-center justify-center bg-red-600/20 hover:bg-red-600 rounded-full border border-red-500/50 text-white transition-all shadow-[0_0_15px_rgba(220,38,38,0.5)]"
            >
              <i className="fa-solid fa-xmark text-2xl"></i>
            </button>
          )}

          <div className="relative w-28 h-28 md:w-36 md:h-36">
            <svg className="w-full h-full transform -rotate-90">
              {/* Background Track */}
              <circle
                cx="50%"
                cy="50%"
                r="45%"
                stroke="rgba(255,255,255,0.05)"
                strokeWidth="5"
                fill="transparent"
              />
              {/* Progress Circle with Pulse logic */}
              <circle
                cx="50%"
                cy="50%"
                r="45%"
                stroke={showClose ? "#ff4d4f" : "#ffb200"}
                strokeWidth="5"
                fill="transparent"
                strokeDasharray="282.7"
                strokeDashoffset={282.7 - (282.7 * progress) / 100}
                strokeLinecap="round"
                className={`transition-all duration-300 ease-out 
                  ${progress >= 98 && !showClose ? "animate-circle-pulse" : ""}`}
              />
            </svg>

            {/* Percentage Display */}
            <div className="absolute inset-0 flex items-center justify-center">
              <span
                className={`text-xl md:text-2xl font-bold tracking-tighter transition-colors ${showClose ? "text-red-500" : "text-white"}`}
              >
                {showClose ? "!" : `${progress}%`}
              </span>
            </div>
          </div>

          <div className="mt-8 flex flex-col items-center px-6">
            <h2
              className={`text-lg md:text-xl font-bold uppercase tracking-[0.2em] transition-all 
              ${showClose ? "text-red-500" : "text-[#ffb200] animate-pulse"}`}
            >
              {showClose ? "Launch Failed" : "Loading......"}
            </h2>

            {showClose ? (
              <p className="text-gray-300 text-sm mt-2 text-center">
                Could not reach the casino server. <br />
                Click the <span className="text-red-500 font-bold">X</span> to
                return.
              </p>
            ) : (
              <p className="text-gray-400 text-xs mt-2 italic opacity-70">
                Please wait while we secure your seat...
              </p>
            )}
          </div>
        </div>
      )}

      {/* {!allEvents.length > 0 && (
                <SkyLoader />
            )} */}
      {loading && <SkyLoader />}

      {/* {
                isEventLoading && <SkyLoader />
            } */}
      <div className="w-full flex justify-center">
        {/* Container: Boxed layout centered (max width 1400px) */}
        <div className="w-full max-w-[75vw] px-2">
          {/* Desktop */}
          {showLoginModal && (
            <LoginModal onClose={() => setShowLoginModal(false)} />
          )}
          <div className="hidden lg:grid grid-cols-12 ">
            {userInfo && (
              <div className="col-span-12 leading-[15px]  bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)]">
                <h4 className="z-10 text-[12px] font-bold relative bg-[linear-gradient(-180deg,_#274253_0%,_#0f191f_82%)] text-[#ffffff] pl-[9px] pr-[4px] py-[4px] inline-block">
                  <i className="fa fa-microphone"></i>
                  <span>&nbsp;News</span>
                </h4>
                <marquee
                  direction="left"
                  scrollamount="5"
                  behavior="scroll"
                  className="w-[90%] text-[#ffffff] inline-table font-bold text-[12px] leading-[21px]"
                >
                  <News />
                </marquee>
              </div>
            )}

            <div className="col-span-12">
              <Carousel autoplay>
                {banners.length > 0 ? (
                  banners?.map((banner) => {
                    return (
                      <div>
                        <img
                          style={{ height: "208px", width: "100%" }}
                          src={`${Appconfig.apiUrl}banner/${banner.image_name}`}
                        />
                      </div>
                    );
                  })
                ) : (
                  <>
                    <div>
                      <img
                        style={{ height: "160px", width: "100%" }}
                        src="/other/slider.webp"
                      />
                    </div>
                  </>
                )}
              </Carousel>
            </div>
            <div className="col-span-12 w-full max-w-7xl mx-auto py-2">
              {/* {isLoading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <svg width="120" height="120" viewBox="0 0 100 100">
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        stroke="#333"
                        strokeWidth="5"
                      />
                      <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        stroke="#ffb200"
                        strokeWidth="5"
                        strokeDasharray="282.7"
                        strokeDashoffset={282.7 - (282.7 * progress) / 100}
                        strokeLinecap="round"
                        style={{ transition: "stroke-dashoffset 0.1s linear" }}
                        transform="rotate(-90 50 50)"
                      />
                    </svg>
                    <div
                      style={{
                        position: "absolute",
                        color: "#fff",
                        fontSize: "20px",
                        fontWeight: "bold",
                        fontFamily: "sans-serif",
                      }}
                    >
                      {progress}%
                    </div>
                  </div>
                </div>
              )} */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {/* Sports Block */}
                <div
                  className="relative bg-black overflow-hidden cursor-pointer"
                  onClick={() => navigate("/inplay?tab=today")}
                >
                  <img
                    className="w-full h-auto"
                    src="/images/banner_sports.webp"
                    alt="sports"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                    <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                      Sports
                    </span>

                    {/* Play Now with diagonal slope */}
                    <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                      <span
                        className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                        aria-hidden="true"
                      />
                      <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                    </span>
                  </div>
                </div>

                {/* Blog Block */}
                <div className="relative overflow-hidden cursor-pointer">
                  <img
                    className="w-full h-auto"
                    src="/images/banner_skyexchangeBlog.png"
                    alt="blog"
                  />
                </div>

                {/* Virtual Cricket / Betradar */}
                <div className="relative overflow-hidden cursor-pointer">
                  <img
                    className="w-full"
                    src="/images/banner_virtualsports.png"
                    alt="virtual"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                    <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                      Virtual Cricket
                    </span>

                    {/* Play Now with diagonal slope */}
                    <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                      <span
                        className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                        aria-hidden="true"
                      />
                      <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* EVO */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("EVZ", "1000000", "EV")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_evo-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        EVO
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* SmartSoft */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151087", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_smartsoft-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Smartsoft
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Royal Gaming */}
                <div
                  className="relative overflow-hidden cursor-pointer"
                  onClick={() => handleCasinoLaunch("DC", "900000", "")}
                >
                  <img
                    className="w-full"
                    src="/images/banner_royalgaming.png"
                    alt="virtual"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                    <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                      Royal Gaming
                    </span>

                    {/* Play Now with diagonal slope */}
                    <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                      <span
                        className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                        aria-hidden="true"
                      />
                      <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Ezugi */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("EZ", "", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_ezugi-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        EZUGI
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Live Casino */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => navigate("/skylivecasino")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_casino-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Live Casino
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Aviator */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151067", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_aviator_xtreme-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        AVIATORX
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Mines */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("SPB", "mines", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_mines-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Mines
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Kitex */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151086", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_kitex-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        KiteX
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Turbo Vortex */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151080", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_turbo_vortex-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Turbo Vortex
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Spribe */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("SPB", "", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_spribe.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Spribe
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Blackjack */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400070", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_blackjack-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Blackjack
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* 7 up down */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600064", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_7up7down-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        7 Up Down
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Andar Bahar */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151014", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_andarBaharVR-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Andar Bahar VR
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Supernowa */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("SN", "", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_supernowa-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Supernowa
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* 7mojos */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("EZ", "507000", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_7mojos-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        7mojos
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Horse Book */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400086", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_horsebook-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        HORSEBOOK
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Minesweeper */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400080", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_minesweeper-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Minesweeper
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Teen Patti */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "900079", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_teenPatti-halfs.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Teen Patti
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Super Over */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "150058", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_superOverVR-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Super Over VR
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Teen Patti 20-20 */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600112", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_TeenPatti2020-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        TeenPatti 20-20
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* NumberKing */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400061", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_NumberKing-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        NumberKing
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Big Small*/}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600086", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_BigSmall-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Big Small
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* TeenPatti Joker */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600110", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_TeenPattiJoker-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        TeenPatti Joker
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* 7up 7down */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600064", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_7up7down-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        7up7down
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Dragon & Tiger */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600087", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_DragonNTiger-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Dragon & Tiger
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Auto Roulette */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("EZ", "541001", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_autoRoulette-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Auto Roulette
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Dus Ka Dum */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "150037", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_DusKaDumVR-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[175px]">
                        Dus Ka Dum (Cards) VR
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Callbreak Quick */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600111", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_CallbreakQuick-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Callbreak Quick
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Sic Bo */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600065", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_SicBo-Jili-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Sic Bo
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Baccarat */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600089", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_Baccarat-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Baccarat
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Bonus Dice */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400081", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_BonusDice-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Bonus Dice
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Heist */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400085", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_Heist-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Heist
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* 5 card poker */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400087", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_5CardPoker-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        5 Card Poker
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Color Game */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400088", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_ColorGame-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Color Games
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* 32 Cards */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400078", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_32card-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        32 Cards
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Rummy */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "600014", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_rummy-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Rummy
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Dragon Tiger */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "150001", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_dragonTiger-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Dragon Tiger
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Worli Matka VR */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151021", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_worliMatkaVR-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Worli Matka VR
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Bet Games */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("QT", "BTV-lobby", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_betgames-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        BetGames
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Andar Bahar */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400071", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_andarBahar-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Andar Bahar
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Sicbo */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400056", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_sicbo-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Sicbo
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* 7 up 7 down */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400067", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_sevenUpDown-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        7 Up 7 Down
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Coin Toss */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400075", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_CoinToss-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Coin Toss
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Teen Patti */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "901017", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_teenPatti-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Teen Patti
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Card Matke */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400062", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_cardMatka-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Card Matka
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {/* Number Matka */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "400061", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_numberMatka-half.png"
                      alt="evo"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Number Matka
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>

                  {/* Bpoker */}
                  <div
                    className="relative overflow-hidden cursor-pointer h-[215px]"
                    onClick={() => handleCasinoLaunch("DC", "151017", "")}
                  >
                    <img
                      className="w-full h-full object-cover"
                      src="/images/banner_bpoker-half.png"
                      alt="smartsoft"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                      <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                        Bpoker
                      </span>

                      {/* Play Now with diagonal slope */}
                      <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                        <span
                          className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                          aria-hidden="true"
                        />
                        <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="grid lg:hidden grid-col-12 relative top-[56px]">
        <div className="col-span-12" style={{ width: "100vw" }}>
          <Carousel autoplay>
            {banners.length > 0 ? (
              banners?.map((banner) => {
                return (
                  <div>
                    <img
                      style={{
                        height: "80px",
                        width: "-webkit-fill-available",
                      }}
                      src={`${Appconfig.apiUrl}banner/${banner.image_name}`}
                    />
                  </div>
                );
              })
            ) : (
              <>
                {/* <div>
                  <img
                    style={{ height: "97px", width: "-webkit-fill-available" }}
                    src="/other/universe-casino.webp"
                  />
                </div> */}
              </>
            )}
          </Carousel>
        </div>

        <div className="col-span-12 w-full max-w-7xl mx-auto py-2 px-[1.6vw]">
          {/* {isLoading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.9)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg width="120" height="120" viewBox="0 0 100 100">
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    fill="none"
                    stroke="#333"
                    strokeWidth="5"
                  />
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    fill="none"
                    stroke="#ffb200"
                    strokeWidth="5"
                    strokeDasharray="282.7"
                    strokeDashoffset={282.7 - (282.7 * progress) / 100}
                    strokeLinecap="round"
                    style={{ transition: "stroke-dashoffset 0.1s linear" }}
                    transform="rotate(-90 50 50)"
                  />
                </svg>
                <div
                  style={{
                    position: "absolute",
                    color: "#fff",
                    fontSize: "20px",
                    fontWeight: "bold",
                    fontFamily: "sans-serif",
                  }}
                >
                  {progress}%
                </div>
              </div>
            </div>
          )} */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {/* Sports Block */}
            <div
              className="relative bg-black overflow-hidden cursor-pointer"
              onClick={() => navigate("/inplay?tab=today")}
            >
              <img
                className="w-full h-auto"
                src="/images/banner_sports.webp"
                alt="sports"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                  Sports
                </span>

                {/* Play Now with diagonal slope */}
                <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                  <span
                    className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                    aria-hidden="true"
                  />
                  <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                </span>
              </div>
            </div>

            {/* Blog Block */}
            <div className="relative overflow-hidden cursor-pointer">
              <img
                className="w-full h-auto"
                src="/images/banner_skyexchangeBlog.png"
                alt="blog"
              />
            </div>

            {/* Virtual Cricket / Betradar */}
            <div className="relative overflow-hidden cursor-pointer">
              <img
                className="w-full"
                src="/images/banner_virtualsports.png"
                alt="virtual"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                <span className="font-bold text-lg ml-2 my-1 truncate overflow-hidden text-ellipsis">
                  Virtual Cricket
                </span>

                {/* Play Now with diagonal slope */}
                <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                  <span
                    className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                    aria-hidden="true"
                  />
                  <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                </span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* EVO */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("EVZ", "1000000", "EV")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_evo-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    EVO
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* SmartSoft */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151087", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_smartsoft-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Smartsoft
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            {/* Royal Gaming */}
            <div
              className="relative overflow-hidden cursor-pointer"
              onClick={() => handleCasinoLaunch("DC", "900000", "")}
            >
              <img
                className="w-full"
                src="/images/banner_royalgaming.png"
                alt="virtual"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                  Royal Gaming
                </span>

                {/* Play Now with diagonal slope */}
                <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                  <span
                    className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                    aria-hidden="true"
                  />
                  <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                </span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Ezugi */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("EZ", "", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_ezugi-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    EZUGI
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Live Casino */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => navigate("/skylivecasino")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_casino-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Live Casino
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Aviator */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151067", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_aviator_xtreme-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    AVIATORX
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Mines */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("SPB", "mines", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_mines-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Mines
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Kitex */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151086", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_kitex-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    KiteX
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Turbo Vortex */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151080", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_turbo_vortex-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Turbo Vortex
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Spribe */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("SPB", "", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_spribe.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Spribe
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Blackjack */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400070", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_blackjack-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Blackjack
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* 7 up down */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600064", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_7up7down-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    7 Up Down
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Andar Bahar */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151014", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_andarBaharVR-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Andar Bahar VR
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Supernowa */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("SN", "", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_supernowa-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Supernowa
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* 7mojos */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("EZ", "507000", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_7mojos-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    7mojos
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Horse Book */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400086", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_horsebook-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    HORSEBOOK
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Minesweeper */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400080", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_minesweeper-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Minesweeper
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Teen Patti */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "900079", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_teenPatti-halfs.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Teen Patti
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Super Over */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "150058", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_superOverVR-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Super Over VR
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Teen Patti 20-20 */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600112", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_TeenPatti2020-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    TeenPatti 20-20
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* NumberKing */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400061", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_NumberKing-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    NumberKing
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Big Small*/}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600086", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_BigSmall-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Big Small
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* TeenPatti Joker */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600110", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_TeenPattiJoker-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    TeenPatti Joker
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* 7up 7down */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600064", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_7up7down-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    7up7down
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Dragon & Tiger */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600087", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_DragonNTiger-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Dragon & Tiger
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Auto Roulette */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("EZ", "541001", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_autoRoulette-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Auto Roulette
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Dus Ka Dum */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "150037", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_DusKaDumVR-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Dus Ka Dum (Cards) VR
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Callbreak Quick */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600111", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_CallbreakQuick-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Callbreak Quick
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Sic Bo */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600065", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_SicBo-Jili-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Sic Bo
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Baccarat */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600089", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_Baccarat-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Baccarat
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Bonus Dice */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400081", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_BonusDice-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Bonus Dice
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Heist */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400085", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_Heist-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Heist
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* 5 card poker */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400087", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_5CardPoker-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    5 Card Poker
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Color Game */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400088", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_ColorGame-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Color Games
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* 32 Cards */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400078", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_32card-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    32 Cards
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Rummy */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "600014", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_rummy-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Rummy
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Dragon Tiger */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "150001", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_dragonTiger-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Dragon Tiger
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Worli Matka VR */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151021", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_worliMatkaVR-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Worli Matka VR
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Bet Games */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("QT", "BTV-lobby", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_betgames-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    BetGames
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Andar Bahar */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400071", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_andarBahar-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Andar Bahar
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Sicbo */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400056", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_sicbo-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Sicbo
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* 7 up 7 down */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400067", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_sevenUpDown-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    7 Up 7 Down
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Coin Toss */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400075", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_CoinToss-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Coin Toss
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Teen Patti */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "901017", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_teenPatti-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Teen Patti
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Card Matke */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400062", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_cardMatka-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Card Matka
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              {/* Number Matka */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "400061", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_numberMatka-half.png"
                  alt="evo"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Number Matka
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>

              {/* Bpoker */}
              <div
                className="relative overflow-hidden cursor-pointer"
                onClick={() => handleCasinoLaunch("DC", "151017", "")}
              >
                <img
                  className="w-full h-full object-cover"
                  src="/images/banner_bpoker-half.png"
                  alt="smartsoft"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white flex justify-between items-center border-b-[5px] border-[#ffb80c] h-[32px]">
                  <span className="font-bold text-sm ml-2 my-1 truncate overflow-hidden text-ellipsis max-w-[75px]">
                    Bpoker
                  </span>

                  {/* Play Now with diagonal slope */}
                  <span className="relative inline-flex items-center bg-[#ffb80c] text-black font-bold">
                    <span
                      className="absolute left-[-8px] top-0 bottom-0 w-4 -skew-x-[26deg] origin-left bg-[#ffb80c]"
                      aria-hidden="true"
                    />
                    <span className="pl-2 pr-2 py-1 text-sm">Play Now</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Home;
